var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"py-6 px-2 white",style:({ height: '100%', width: '100%' }),attrs:{"outlined":"","elevation":5}},[_c('div',{staticClass:"title-tag-cloud mb-3"},[_vm._v(_vm._s(_vm.title))]),_c('vue-word-cloud',{style:({ height: '90%', width: '80%', margin: 'auto' }),attrs:{"words":_vm.words,"font-family":_vm.fontFamily,"color":function (ref) {
	var weight = ref[1];

	return _vm.colorRender(weight);
},"rotation-unit":'turn',"rotation":0,"spacing":1,"font-size-ratio":4,"animation-overlap":2,"animation-duration":2000},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var text = ref.text;
return [_c('div',{staticStyle:{"cursor":"pointer"}},[_vm._v(" "+_vm._s(text)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }